const defaultStructure = {
  donor_config_type: ['Select Donor Config Type', 'floor', 'target', 'ceiling'],
  donor_category: ['Select Donor Category', 'all', 'political', 'nonprofit', 'cross_sector'],
  donor_recency: ['Select Donor Recency', 15, 30, 45, 60, 90],
  client_type: ['Select Client Type', 'political', 'nonprofit'],
  curate_frequency: ['Select Frequency', 'weekly'],
  email_validation_provider: ['Select Email Validation Provider', 'briteverify', 'kickbox'],
  action_platform: [
    'Select Data Source',
    'actionkit',
    'bigquery',
    'bsd',
    'cheetahmail',
    'custom',
    'engaging_networks',
    'flat_file',
    'hub',
    'mailchimp',
    'ngp_everyaction',
    'quorum',
    'salesforce',
    'salsa',
    'salsa_engage',
    'actionkit, hub',
    'engaging_networks, ngp_everyaction',
  ],
  people_platform: [
    'Select Data Source',
    'action_network',
    'actionkit',
    'bigquery',
    'braze',
    'bsd',
    'campaign_monitor',
    'cheetahmail',
    'civis',
    'constant_contact',
    'custom',
    'engaging_networks',
    'flat_file',
    'hub',
    'hubspot',
    'luminate',
    'mailchimp',
    'marketo',
    'nationbuilder',
    'ngp_everyaction',
    'numero',
    'pardot',
    'quorum',
    'raisers_edge',
    'salesforce',
    'salsa',
    'salsa_engage',
    'sfmc',
    'switchboard',
    'actionkit, hub',
    'actionkit, ngp_everyaction',
    'braze, luminate, marketo',
    'civis, sfmc',
    'engaging_networks, ngp_everyaction',
    'engaging_networks, raisers_edge',
    'flat_file, hubspot',
    'flat_file, sfmc',
    'luminate, sfmc',
    'luminate, marketo',
    'mailchimp, nationbuilder',
    'mailchimp, ngp_everyaction',
    'mailchimp, salesforce',
    'mailchimp, raisers_edge',
    'mailchimp, braze',
  ],
  transaction_platform: [
    'Select Data Source',
    'actblue',
    'actionkit',
    'bigquery',
    'bsd',
    'civis',
    'cheetahmail',
    'classy',
    'custom',
    'engaging_networks',
    'flat_file',
    'fundraise_up',
    'funraise',
    'hub',
    'kindest',
    'luminate',
    'ngp_everyaction',
    'raisers_edge',
    'salesforce',
    'salsa',
    'salsa_engage',
    'actblue, actionkit',
    'actblue, civis',
    'actblue, ngp_everyaction',
    'actblue, salsa',
    'engaging_networks, luminate',
    'engaging_networks, ngp_everyaction',
    'engaging_networks, fundraise_up',
    'flat_file, luminate',
    'fundraise_up, luminate',
    'mailchimp, ngp_everyaction',
  ],
  exhaust_platform: [
    'Select Data Source',
    'acoustic',
    'acoustic_trilogy',
    'action_network',
    'actionkit',
    'bigquery',
    'braze',
    'bsd',
    'campaign_monitor',
    'cheetahmail',
    'civicrm',
    'constant_contact',
    'custom',
    'engaging_networks',
    'flat_file',
    'hubspot',
    'luminate',
    'luminate_ftp',
    'mailchimp',
    'marketo',
    'ngp_everyaction',
    'numero',
    'pardot',
    'quorum',
    'salsa',
    'salsa_engage',
    'sfmc',
    'switchboard',
    'actionkit, acoustic_trilogy',
    'actionkit, ngp_everyaction',
    'action_network, mailchimp',
    'braze, luminate, marketo',
    'cheetahmail, sfmc',
    'engaging_networks, luminate',
    'engaging_networks, ngp_everyaction',
    'flat_file, hubspot',
    'flat_file, sfmc',
    'luminate, marketo',
    'mailchimp, ngp_everyaction',
    'mailchimp, braze',
  ],
  sms_platform: ['Select Data Source', 'tatango', 'scale_to_win', 'switchboard', 'tatango, scale_to_win', 'tatango, switchboard', 'scale_to_win, switchboard', 'tatango, scale_to_win, switchboard'],
  transactions_offline_platform: ['Select Data Source', 'flat_file', 'raisers_edge', 'salesforce'],
  timezone: ['Select Client Timezone', 'America_New_York'],
  fiscal_year_start: ['Select Month', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  sector: ['Select Sector', 'Animal Welfare', 'Arts and Culture', 'Disaster and International Relief', 'Committee', 'Congress', 'Environment and Wildlife', 'Faith Communities', 'Food Bank', 'Governor', 'Gun Violence Prevention', 'Health Services and Research', 'Higher Education', 'Hospital Foundations', 'Human and Social Services', 'Local', 'Pac/Org', 'President', 'Public Broadcasting Station', 'Public/Society Benefit', 'Senate', 'Veteran Services'],
  identity: [
    'Jan 6',
    'Abortion Rights',
    'Advocacy',
    'Af-Am',
    'Animal Welfare',
    'Anti Corruption',
    'Anti Trump',
    'Anti War',
    'Arts and Culture',
    'Asian American',
    'Attorney General',
    'Bipartisan',
    'Black Leadership',
    'Campaign Finance',
    'Children',
    'Civil Rights',
    'Climate',
    'Committee',
    'Disaster Relief',
    'District Attorney',
    'Economic',
    'Education',
    'Emergency Response',
    'Environment',
    'Foreign Policy',
    'Former House',
    'Former Senate',
    'Governor',
    'Gun Violence Prevention',
    'Healthcare',
    'House',
    'Housing',
    'Humanitarian Aid',
    'Hunger',
    'Immigration Reform',
    'International',
    'Incumbent',
    'Indigenous',
    'Jewish American',
    'Labor',
    'Latinx',
    'Law Enforcement',
    'Leadership',
    'Legal',
    'LGBT',
    'Local',
    'Mayor',
    'Medicare for All',
    'Media',
    'Military',
    'Millennial',
    'Minority',
    'Mobilization',
    'Moderate',
    'Muslim',
    'National Security',
    'Nonprofit',
    'PAC',
    'Populist',
    'Progressive',
    'Pro Choice',
    'Pro Democracy',
    'Public Health',
    'Rapid Response',
    'Reproductive Rights',
    'Rural',
    'Senate',
    'Social Justice',
    'SOS',
    'Statewide',
    'State Leg',
    'State Party',
    'STEM',
    'Suburban',
    'Ukraine Policy',
    'Veteran',
    'Voting Rights',
    'Women',
    'Working Class',
  ],
};

// used when the user selects a value that should reset the field to an empty string or array
const resetFieldValues = [
  'Select Data Source',
  'Select Donor Config Type',
  'Select Donor Category',
  'Select Email Validation Provider',
  'Select Frequency',
  'Select Client Timezone',
  'Select Month',
  'Select Sector',
  'Select Donor Recency',
];

// if array of numbers, include the element in arrayFields as well
const intFields = [
  'actblue_entity_ids',
  'curate_days',
  'goop_client_ids',
  'numero_account_ids',
  'share_cap_max_shares',
  'share_cap_months',
  'sfg_surveys_client_ids',
  'tatango_client_id',
  'totem_client_ids',
];

// if array of numbers, include the element in intFields as well
const arrayFields = [
  'actblue_entity_ids',
  'facebook_account_ids',
  'google_account_ids',
  'people_platform',
  'action_platform',
  'transaction_platform',
  'exhaust_platform',
  'sms_platform',
  'transactions_offline_platform',
  'suppressed_domains',
  'facebook_locations',
  'bing_account_ids',
  'twitter_account_ids',
  'outbrain_account_ids',
  'ngp_actblue_manual_codes',
  'numero_account_ids',
  'multi_member_clients',
  'multi_member_sms_clients',
  'multi_member_mid_level_clients',
  'stw_subaccount_ids',
  'stw_non_coop_subaccount_ids',
  'goop_client_ids',
  'totem_client_ids',
  'inbox_monster_rule',
  'email_configurations',
  'sms_configurations',
];

export {
  defaultStructure, resetFieldValues, intFields, arrayFields,
};
